import { ArrowRight } from 'lucide-react';
import { espaceDe } from './apparence';

/**
 * L'appel à l'action de bas de page.
 *
 * ========================================================================
 * DEUX STYLES, ET UN SECOND BOUTON
 * ========================================================================
 *
 * `style: "bandeau"` (défaut) — un pavé au dégradé de la charte, texte blanc.
 * Il arrête le regard : c'est ce qu'il faut pour convertir en fin de page de
 * vente.
 *
 * `style: "sobre"` — une phrase grise centrée et les boutons en dessous, sans
 * pavé coloré. C'est ce qu'il faut quand la page vient de dire « C'est fait ! »
 * dans un bandeau vert : deux aplats colorés l'un sous l'autre se disputent
 * l'attention, et le second efface le premier.
 *
 * LE SECOND BOUTON est facultatif. Une page d'aide propose souvent deux
 * suites — « continuer » et « en savoir plus » —, et les présenter côte à
 * côte laisse choisir plutôt que d'imposer une seule porte.
 *
 * Les liens passent par la liste blanche du serveur (relatif, https: ou
 * mailto:) : rien à vérifier ici, la validation a eu lieu à l'écriture.
 */
const BandeauCtaBloc = ({ bloc }) => {
    if (!bloc?.titre && !bloc?.lienTexte) return null;

    const sobre = String(bloc.style || '').toLowerCase() === 'sobre';
    const aSecondLien = Boolean(bloc.lienSecondaireTexte && bloc.lienSecondaire);
    // mb-10 reste la marge par defaut des deux styles : voir espaceDe.
    const espace = espaceDe(bloc.espace, 'mb-10');

    if (sobre) {
        return (
            <section className={`${espace} text-center`} data-testid="bloc-bandeauCta">
                {/* mb-4 ET NON mb-6 : la phrase de InstallAppPage se tient
                    pres de ses boutons, qu'elle introduit. */}
                {bloc.titre && (
                    <p className="text-gray-600 mb-4">{bloc.titre}</p>
                )}
                {bloc.sousTitre && (
                    <p className="text-gray-500 text-sm mb-6 max-w-xl mx-auto">{bloc.sousTitre}</p>
                )}

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    {bloc.lienTexte && bloc.lien && (
                        <a
                            href={bloc.lien}
                            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-cabaza-purple to-cabaza-pink text-white rounded-xl font-semibold hover:shadow-lg hover:scale-[1.02] transition-all"
                        >
                            {bloc.lienTexte}
                            <ArrowRight className="w-5 h-5" />
                        </a>
                    )}

                    {aSecondLien && (
                        <a
                            href={bloc.lienSecondaire}
                            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-700 border border-gray-200 rounded-xl font-semibold hover:bg-gray-50 transition-all"
                        >
                            {bloc.lienSecondaireTexte}
                        </a>
                    )}
                </div>
            </section>
        );
    }

    return (
        <section className={espace} data-testid="bloc-bandeauCta">
            <div className="rounded-2xl px-6 py-8 text-center bg-gradient-to-r from-cabaza-purple to-cabaza-pink">
                {bloc.titre && (
                    <h2 className="text-xl md:text-2xl font-bold text-white mb-2">{bloc.titre}</h2>
                )}
                {bloc.sousTitre && (
                    <p className="text-white/90 mb-5 max-w-xl mx-auto">{bloc.sousTitre}</p>
                )}

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    {bloc.lienTexte && bloc.lien && (
                        <a
                            href={bloc.lien}
                            className="inline-flex items-center justify-center px-6 py-3 rounded-xl font-semibold text-cabaza-purple bg-white hover:bg-gray-50 transition"
                        >
                            {bloc.lienTexte}
                        </a>
                    )}

                    {aSecondLien && (
                        <a
                            href={bloc.lienSecondaire}
                            className="inline-flex items-center justify-center px-6 py-3 rounded-xl font-semibold text-white border border-white/60 hover:bg-white/10 transition"
                        >
                            {bloc.lienSecondaireTexte}
                        </a>
                    )}
                </div>
            </div>
        </section>
    );
};

export default BandeauCtaBloc;
